export const packedValue = ({ bigValue, maxExp, minExp }: any) => {
  let value;
  let exp = minExp;

  while (bigValue.e >= 3 && exp < maxExp) {
    exp += 3;
    bigValue = bigValue.div(1000);
  }

  if (bigValue.e < 0) {
    value = bigValue.toFixed(-1 * bigValue.e + 2);
  } else {
    value = bigValue.toFixed(exp + 3);
  }

  if (value.indexOf(".") !== -1) {
    while (value.endsWith("0")) {
      value = value.substring(0, value.length - 1);
    }

    if (value.endsWith(".")) {
      value = value.substring(0, value.length - 1);
    }
  }

  value = parseFloat(value).toFixed(3);

  return {
    exp, value
  };
};

export default { packedValue };